var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDemo = function SvgDemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 0A2.297 2.297 0 0 0 .333 2.333v4a2.297 2.297 0 0 0 2.334 2.334h8.666a2.297 2.297 0 0 0 2.334-2.334v-4A2.297 2.297 0 0 0 11.334 0zM7 10c.368 0 .667.299.667.667v.666h2.667a.667.667 0 0 1 0 1.334H3.667a.667.667 0 0 1 0-1.334h2.667v-.666c0-.368.298-.667.666-.667"
  })));
};
export default SvgDemo;